import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-[100svh] flex flex-col items-center justify-center px-4 py-20 overflow-hidden bg-navy-900" data-id="element-77">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-78" />

      <motion.div className="relative z-10 w-full max-w-4xl mx-auto flex flex-col items-center text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-79">
        <motion.div variants={itemVariants} className="mb-8" data-id="element-80">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-gold/30 bg-gold/10 text-gold text-sm font-semibold tracking-widest uppercase" data-id="element-81">
            <motion.span animate={{
            opacity: [0.5, 1, 0.5]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} data-id="element-82">
              ★★★
            </motion.span>
            <span data-id="element-83">EDICIÓN LIMITADA MUNDIAL 2026</span>
            <motion.span animate={{
            opacity: [0.5, 1, 0.5]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            delay: 1
          }} data-id="element-84">
              ★★★
            </motion.span>
          </div>
        </motion.div>

        <motion.h1 variants={itemVariants} className="text-6xl md:text-8xl lg:text-9xl font-bebas text-transparent bg-clip-text bg-gradient-to-b from-white to-white/70 leading-[0.9] mb-6 drop-shadow-lg" data-id="element-85">
          LA COLECCIÓN QUE
          <br data-id="element-86" />
          NINGÚN KIOSCO VA A TENER.
        </motion.h1>

        <motion.p variants={itemVariants} className="text-xl md:text-2xl text-white font-semibold max-w-2xl leading-snug mb-4" data-id="element-87">
          El Pack Definitivo de la Scaloneta: Mazo de Truco + Edición Especial
          UNO.
        </motion.p>

        <motion.p variants={itemVariants} className="text-lg md:text-xl text-white/80 max-w-2xl font-light leading-relaxed mb-12" data-id="element-88">
          Llevá la mística de las 3 estrellas a todos lados. Edición
          limitadísima Mundial 2026.{' '}
          <span className="inline-block mt-2 text-gold font-bold text-xl md:text-2xl drop-shadow-[0_0_20px_rgba(212,175,55,0.5)] animate-pulse" data-id="element-89">
            🥩 ¡Por menos de lo que sale una tira de asado!
          </span>
        </motion.p>

        <motion.div variants={itemVariants} className="mb-10" data-id="element-90">
          <a href="#offer" className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-gold text-navy-900 font-bold text-lg rounded-lg overflow-hidden hover:scale-105 active:scale-95 shadow-[0_0_40px_rgba(212,175,55,0.3)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)] animate-[pulse_2s_ease-in-out_infinite] no-underline" data-id="element-91">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-92" />
            <span className="relative z-10" data-id="element-93">QUIERO MI EDICIÓN LIMITADA</span>
          </a>
        </motion.div>

        {/* Product Image */}
        <motion.div variants={itemVariants} className="w-full max-w-3xl mx-auto mt-4" data-id="element-94">
          <img src="https://cdn.magicpatterns.com/uploads/b7SQdRQLnvZAp194QHU8Kx/f86ab303-dafb-456f-866d-0942f48008c8.png" alt="Pack Definitivo de la Scaloneta — Mazo de Truco + Edición Especial UNO" className="w-full h-auto rounded-2xl shadow-[0_25px_60px_-12px_rgba(0,0,0,0.7),0_0_30px_rgba(212,175,55,0.15)]" data-id="element-95" />
        </motion.div>
      </motion.div>
    </section>;
}